import { AgGridReact } from "ag-grid-react";
import React, { useEffect, useState } from "react";
import { Col, Modal, Row } from "react-bootstrap";
import Select from "react-select";
import { toast } from "react-toastify";
import dotracking from "../../../trackinglogs";
import trackobj from "../../../trackingpages.json";
import Swal from "sweetalert2";
import { useNavigate, useParams } from "react-router-dom";
import {
  productdetail,
  schoollist,
  webpagemappedremove,
  webpagenewproduct,
  webpageproductlist,
} from "../../../../services/superadmin";
import { funderlist, grpschlist } from "../../../../services/master";

export const WebpageList = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [filterProduct, setFilterProduct] = useState([]);
  const [errorMsg, setErrorMsg] = useState("");

  const columnDefs = [
    {
      headerName: "Actions",
      field: "id",
      width: 100,
      sortable: true,
      resizable: true,
      filter: false,
      floatingFilter: false,
      cellRenderer: function (params) {
        return (
          <div className="text-center">
            <a
              title="Delete School"
              className="btn-sm btn-danger"
              onClick={() => deletewebpage(params)}
            >
              <i className="fa fa-trash fa-lg"></i>
            </a>
          </div>
        );
      },
    },
    {
      headerName: "School",
      field: "school_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
  ];

  const columnFDefs = [
    {
      headerName: "Actions",
      field: "id",
      width: 100,
      sortable: true,
      resizable: true,
      filter: false,
      floatingFilter: false,
      cellRenderer: function (params) {
        return (
          <div className="text-center">
            <a
              title="Delete Funder"
              className="btn-sm btn-danger"
              onClick={() => deletewebpage(params)}
            >
              <i className="fa fa-trash fa-lg"></i>
            </a>
          </div>
        );
      },
    },
    {
      headerName: "Funder",
      field: "funder_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
  ];

  const columnGDefs = [
    {
      headerName: "Actions",
      field: "id",
      width: 100,
      sortable: true,
      resizable: true,
      filter: false,
      floatingFilter: false,
      cellRenderer: function (params) {
        return (
          <div className="text-center">
            <a
              title="Delete Funder"
              className="btn-sm btn-danger"
              onClick={() => deletewebpage(params)}
            >
              <i className="fa fa-trash fa-lg"></i>
            </a>
          </div>
        );
      },
    },
    {
      headerName: "Group of School",
      field: "group_of_school_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
  ];

  function deletewebpage(list) {
    Swal.fire({
      text: "Are you sure want to delete?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#ac0404",
      cancelButtonColor: "#6259ca",
      confirmButtonText: "Delete",
      allowOutsideClick: false,
    }).then((result) => {
      if (result.isConfirmed) {
        if (urllink === "schoolproducts") {
          dotracking(
            "status icon in school product list for " +
              list.data.school_name +
              " (" +
              list.data.school_funder_group_id +
              ") school $$ " +
              trackobj.schpdtlistheading
          );
        } else if (urllink === "funderproducts") {
          dotracking(
            "status icon in funder product list for " +
              list.data.funder_name +
              " (" +
              list.data.school_funder_group_id +
              ") funder $$ " +
              trackobj.fundpdtlistheading
          );
        } else if (urllink === "groupproducts") {
          dotracking(
            "status icon in group of school product list for " +
              list.data.group_of_school_name +
              " (" +
              list.data.school_funder_group_id +
              ") funder $$ " +
              trackobj.fundpdtlistheading
          );
        }

        webpagemappedremove(list.data.id).then((response) => {
          if (response.status === true) {
            listall(urllink);
            toast.success(response.message);
          }
        });
      }
    });
  }
  const [urllink, setUrlLink] = useState("");
  const [pdtname, setPdtName] = useState("");
  const [schweb, setSchWeb] = useState(false);
  const [funweb, setFunWeb] = useState(false);
  const [grpweb, setGrpWeb] = useState(false);

  useEffect(() => {
    const url = window.location.href;
    const head = url.split("/#/");
    const link = head[1].split("/");
    setUrlLink(link[1]);
    listall(link[1]);
    setSchWeb(false);
    setFunWeb(false);
    setGrpWeb(false);
    productdetail(id).then((res) => {
      if (res.status === true && res.data.product_details) {
        setPdtName(res.data.product_details.product_name);
        if (res.data.product_details.school_display == 0) {
          setSchWeb(false);
        } else if (
          res.data.product_details.school_display == 1 
        ) {
          setSchWeb(true);
        }

        if (res.data.product_details.funder_display == 0) {
          setFunWeb(false);
        } else if (
          res.data.product_details.funder_display == 1 
        ) {
          setFunWeb(true);
        }

        if (res.data.product_details.group_display == 0) {
          setGrpWeb(false);
        } else if (
          res.data.product_details.group_display == 1 
        ) {
          setGrpWeb(true);
        }
      }
    });

    if (localStorage.getItem("Role") === "1") {
      schoollist().then((response) => {
        if (response.status === true) {
          let arr = [];
          if (response.data.details.length !== 0) {
            for (let i = 0; i < response.data.details.length; i++) {
              arr.push({
                value: response.data.details[i].id,
                label:
                  response.data.details[i].school_name +
                  " - " +
                  response.data.details[i].school_unique_no,
              });
            }
          }
          setSList(arr);
        }
      });

      funderlist().then((response) => {
        if (response.status === true) {
          let arr = [];

          if (response.data.funders_list.length !== 0) {
            for (let i = 0; i < response.data.funders_list.length; i++) {
              arr.push({
                value: response.data.funders_list[i].id,
                label: response.data.funders_list[i].funder_name,
              });
            }
          }
          setFList(arr);
        }
      });

      grpschlist().then((response) => {
        if (response.status === true) {
          let arr = [];
          if (response.data.funders_list.length !== 0) {
            for (let i = 0; i < response.data.funders_list.length; i++) {
              arr.push({
                value: response.data.funders_list[i].id,
                label: response.data.funders_list[i].group_of_school_name,
              });
            }
          }
          setGList(arr);
        }
      });
    }
  }, []);

  function listall(ltype) {
    setFilterProduct([]);
    if (ltype === "schoolproducts") {
      webpageproductlist(id, 1).then((res) => {
        if (res.status === true) {
          setFilterProduct(res.data.webpage_list);
        }
      });
    } else if (ltype === "funderproducts") {
      webpageproductlist(id, 2).then((res) => {
        if (res.status === true) {
          setFilterProduct(res.data.webpage_list);
        }
      });
    } else if (ltype === "groupproducts") {
      webpageproductlist(id, 3).then((res) => {
        if (res.status === true) {
          setFilterProduct(res.data.webpage_list);
        }
      });
    }
  }

  const [show, setShow] = useState(false);
  const [slist, setSList] = useState([]);
  const [flist, setFList] = useState([]);
  const [glist, setGList] = useState([]);

  const [schid, setSchID] = useState("");
  const [funid, setFunID] = useState("");
  const [grpid, setGrpID] = useState("");

  function handleshow() {
    setShow(true);
    setSchID("");
    setFunID("");
    setGrpID("");
  }

  function handleclose() {
    setShow(false);
    setSchID("");
    setFunID("");
    setGrpID("");
  }

  function backlist() {
    if (localStorage.getItem("Role") === "1") {
      if (urllink === "schoolproducts") {
        dotracking(
          "back button in school product list $$ " + trackobj.pdtheading
        );
      } else if (urllink === "funderproducts") {
        dotracking(
          "back button in funder product list $$ " + trackobj.pdtheading
        );
      } else if (urllink === "groupproducts") {
        dotracking(
          "back button in group of school product list $$ " +
            trackobj.pdtheading
        );
      }
      navigate("/superadmin/allproducts");
    }
  }

  function handleSchool(e) {
    if (e !== null) {
      setSchID(e);
    } else {
      setSchID("");
    }
  }

  function handleFunder(e) {
    if (e !== null) {
      setFunID(e);
    } else {
      setFunID("");
    }
  }

  function handleGroup(e) {
    if (e !== null) {
      setGrpID(e);
    } else {
      setGrpID("");
    }
  }

  function handleadd(e) {
    e.preventDefault();
    var emsg = "";
    if (schid.length != 0 || funid.length != 0 || grpid.length != 0) {
      const temp = new FormData();
      temp.append("admin_id", localStorage.getItem("UID"));
      temp.append("product_unique_id", id);
      if (urllink === "schoolproducts") {
        temp.append("school_display", 1);
        temp.append("schools_count", schid.length);
        temp.append("funder_display", 0);
        temp.append("group_display", 0);
        emsg = " Schools - ";
        for (let i = 0; i < schid.length; i++) {
          emsg = emsg + schid[i].label + ", ";
          temp.append("schools_id_" + [i + 1], schid[i].value);
        }
      }

      if (urllink === "funderproducts") {
        temp.append("funder_display", 1);
        temp.append("funders_count", funid.length);
        temp.append("school_display", 0);
        temp.append("group_display", 0);
        emsg = " Funders - ";
        for (let i = 0; i < funid.length; i++) {
          emsg = emsg + funid[i].label + ", ";
          temp.append("funders_id_" + [i + 1], funid[i].value);
        }
      }

      if (urllink === "groupproducts") {
        temp.append("school_display", 0);
        temp.append("funder_display", 0);
        temp.append("group_display", 1);
        temp.append("groups_count", grpid.length);
        emsg = " Groups - ";
        for (let i = 0; i < grpid.length; i++) {
          emsg = emsg + grpid[i].label + ", ";
          temp.append("groups_id_" + [i + 1], grpid[i].value);
        }
      }
      dotracking("add button in " + emsg + " $$ " + trackobj.pdtheading);
      webpagenewproduct(temp).then((res) => {
        if (res.status === true) {
          handleclose();
          listall(urllink);
          toast.success(res.message);
        }
      });
    } else {
      if (urllink === "schoolproducts") {
        setErrorMsg("Please select at least one school");
      } else if (urllink === "funderproducts") {
        setErrorMsg("Please select at least one funder");
      } else if (urllink === "groupproducts") {
        setErrorMsg("Please select at least one group");
      }
    }
  }

  return (
    <div className="side-app">
      <div className="page-header">
        <div className="breadcrumb">
          {urllink === "schoolproducts" && (
            <h4 className="mb-0">School Products List</h4>
          )}
          {urllink === "funderproducts" && (
            <h4 className="mb-0">Funder Products List</h4>
          )}
          {urllink === "groupproducts" && (
            <h4 className="mb-0">Group of School Products List</h4>
          )}
        </div>
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a>Products</a>
          </li>
          {urllink === "schoolproducts" && (
            <li className="breadcrumb-item active" aria-current="page">
              School Products List
            </li>
          )}
          {urllink === "funderproducts" && (
            <li className="breadcrumb-item active" aria-current="page">
              Funder Products List
            </li>
          )}
          {urllink === "groupproducts" && (
            <li className="breadcrumb-item active" aria-current="page">
              Group of School Products List
            </li>
          )}
        </ol>
      </div>

      <div className="card">
        <div className="card-body">
          <div className="row">
            <div className="col-md-8">
              <h4>{pdtname}</h4>
            </div>
            <div className="col-md-4">
              <div className="text-right">
                {urllink === "schoolproducts" && (
                  <a className="btn btn-success me-2" onClick={handleshow}>
                    <i className="fa fa-plus"></i> Add School{" "}
                  </a>
                )}
                {urllink === "funderproducts" && (
                  <a className="btn btn-success me-2" onClick={handleshow}>
                    <i className="fa fa-plus"></i> Add Funder{" "}
                  </a>
                )}
                {urllink === "groupproducts" && (
                  <a className="btn btn-success me-2" onClick={handleshow}>
                    <i className="fa fa-plus"></i> Add Group of School{" "}
                  </a>
                )}

                <a className="btn btn-gray" onClick={backlist}>
                  <i className="fe fe-corner-up-left"></i> Back
                </a>
              </div>
            </div>
          </div>
          {urllink === "schoolproducts" &&
            schweb && (
              <h4 className="text-center text-danger mt-3">
                This Product is set to be Visible for all the School webpages{" "}
              </h4>
            )}
          {urllink === "schoolproducts" &&
            !schweb && (
              <h4 className="text-center text-danger mt-3">
                This Product is set to be not Visible for all the School
                webpages{" "}
              </h4>
            )}

          {urllink === "funderproducts" &&
            funweb && (
              <h4 className="text-center text-danger mt-3">
                This Product is set to be Visible for all the Funder webpages{" "}
              </h4>
            )}
          {urllink === "funderproducts" &&
            !funweb && (
              <h4 className="text-center text-danger mt-3">
                This Product is set to be not Visible for all the Funder
                webpages{" "}
              </h4>
            )}

          {urllink === "groupproducts" &&
            grpweb && (
              <h4 className="text-center text-danger mt-3">
                This Product is set to be Visible for all the Group of School
                webpages{" "}
              </h4>
            )}
          {urllink === "groupproducts" &&
            !grpweb  && (
              <h4 className="text-center text-danger mt-3">
                This Product is set to be not Visible for all the Group of
                webpages{" "}
              </h4>
            )}

          <div className="ag-theme-alpine ag-style mt-2">
            {urllink === "schoolproducts" && (
              <AgGridReact
                columnDefs={columnDefs}
                rowData={filterProduct}
                pagination="true"
                paginationPageSize="10"
                sortingOrder={["asc", "desc"]}
                suppressExcelExport={true}
                suppressDragLeaveHidesColumns={true}
                domLayout="autoWidth"
                onGridReady={(params) => {
                  params.api.sizeColumnsToFit();
                }}
              />
            )}
            {urllink === "funderproducts" && (
              <AgGridReact
                columnDefs={columnFDefs}
                rowData={filterProduct}
                pagination="true"
                paginationPageSize="10"
                sortingOrder={["asc", "desc"]}
                suppressExcelExport={true}
                suppressDragLeaveHidesColumns={true}
                domLayout="autoWidth"
                onGridReady={(params) => {
                  params.api.sizeColumnsToFit();
                }}
              />
            )}
            {urllink === "groupproducts" && (
              <AgGridReact
                columnDefs={columnGDefs}
                rowData={filterProduct}
                pagination="true"
                paginationPageSize="10"
                sortingOrder={["asc", "desc"]}
                suppressExcelExport={true}
                suppressDragLeaveHidesColumns={true}
                domLayout="autoWidth"
                onGridReady={(params) => {
                  params.api.sizeColumnsToFit();
                }}
              />
            )}
          </div>
        </div>
      </div>

      <Modal show={show} size="lg" onHide={handleclose}>
        <Modal.Header>
          <h4> Add Schools</h4>
        </Modal.Header>
        <Modal.Body>
          <Row className="row-sm mx-0">
            {urllink === "schoolproducts" && (
              <Col lg={12} md={12}>
                <div className="form-group">
                  <label className="mb-2">
                    School <span className="errortext"> *</span>
                  </label>
                  <Select
                    className="dropdown"
                    placeholder="Select School"
                    value={schid}
                    options={slist}
                    onChange={handleSchool}
                    isSearchable={true}
                    isMulti
                    isClearable
                    hidden
                  />
                </div>
              </Col>
            )}
            {urllink === "funderproducts" && (
              <Col lg={12} md={12}>
                <div className="form-group">
                  <label className="mb-2">
                    Funder <span className="errortext"> *</span>
                  </label>
                  <Select
                    className="dropdown"
                    placeholder="Select Funder"
                    value={funid}
                    options={flist}
                    onChange={handleFunder}
                    isSearchable={true}
                    isMulti
                    isClearable
                    hidden
                  />
                </div>
              </Col>
            )}
            {urllink === "groupproducts" && (
              <Col lg={12} md={12}>
                <div className="form-group">
                  <label className="mb-2">
                    Group of School <span className="errortext"> *</span>
                  </label>
                  <Select
                    className="dropdown"
                    placeholder="Select Group of School"
                    value={grpid}
                    options={glist}
                    onChange={handleGroup}
                    isSearchable={true}
                    isMulti
                    isClearable
                    hidden
                  />
                </div>
              </Col>
            )}

            {errorMsg !== "" && <span className="errortext">{errorMsg}</span>}
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <a className="btn btn-danger" onClick={handleclose}>
            Close
          </a>

          <a className="btn btn-success" onClick={handleadd}>
            Add
          </a>
        </Modal.Footer>
      </Modal>
    </div>
  );
};
